import { apiClient } from "./apiClient"


// default api end point
export const getDefaultApi = 
    () => apiClient.get('/');

export const getDoctorsbyDeptId = (deptId) => 
    apiClient.get(`/doctors/by-department/${deptId}`);

export const bookAppointment = (appointmentData) => {
    return apiClient.post('/add_appointment', appointmentData);
};